import React, { useContext, useState } from "react";
import {
  Route,
  Routes,
  NavLink,
  useLocation,
  useNavigate,
} from "react-router-dom";
import MainListChat from "../pages/chat/list/MainListChat";
import Chat from "../pages/chat/Chat";
import { Nav } from "react-bootstrap";
import ChatArea from "../pages/chat/ChatArea";
import { ChatContext } from "../context/chat/ChatContext";
import { types } from "../types/types";

const RouterChat = () => {
  const { chatState, dispatch } = useContext(ChatContext);

  const location = useLocation();
  const navigate = useNavigate();
  const [dynamicTabs, setDynamicTabs] = useState([]);

  // Función para abrir una nueva pestaña dinámica
  const handleOpenChatTab = (user) => {
    const exists = dynamicTabs.find((tab) => tab.id === user.id);
    if (!exists) {
      setDynamicTabs([
        ...dynamicTabs,
        { id: user.id, name: user.first_name + " " + user.last_name, user },
      ]);
    }
    navigate(`${user.id}`);
  };

  // Función para cerrar una pestaña dinámica
  const handleCloseTab = (id) => {
    const newTabs = dynamicTabs.filter((tab) => tab.id !== id);
    setDynamicTabs(newTabs);

    // Si estás en esa pestaña, redirige a otra
    if (location.pathname === `/chat/${id}`) {
      navigate("/chat/filter");
    }
  };

  const activeChat = (user) => {
    dispatch({
      type: types.selectChat,
      payload: user,
    });
  };

  return (
    <div>
      <Nav variant="tabs" activeKey={location.pathname}>
        {/* Tabs fijos */}
        <Nav.Item>
          <Nav.Link
          className="fw-bolder"
            as={NavLink}
            to="history"
            eventKey="/chat/history"
            onClick={() => {
              dispatch({
                type: types.closeChat,
                payload: 0,
              });
            }}
          >
            Historial
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
          className="fw-bolder"

            as={NavLink}
            to="filter"
            eventKey="/chat/filter"
            onClick={() => {
              dispatch({
                type: types.closeChat,
                payload: 0,
              });
            }}
          >
            Inicio
          </Nav.Link>
        </Nav.Item>

        {/* Tabs dinámicos */}
        {dynamicTabs.map((tab) => (
          <Nav.Item key={tab.id}>
            <Nav.Link
              as={NavLink}
              
              to={`${tab.id}`}
              eventKey={`/chat/${tab.id}`}
              className="d-flex align-items-center gap-1 fw-bold"
              onClick={() => activeChat(tab.user)}
            >
              <span>{tab.name}</span>
              <span
                className="text-danger ms-2"
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  handleCloseTab(tab.id);
                }}
              >
                <li className="mdi mdi-close-box "></li>
              </span>
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>

      {/* Rutas */}
      <Routes>
        <Route
          path="filter"
          element={<MainListChat openChatTab={handleOpenChatTab} />}
        />
        <Route path="history" element={<Chat />} />
        <Route path=":id" element={<ChatArea />} />
        <Route
          path="*"
          element={<MainListChat openChatTab={handleOpenChatTab} />}
        />
      </Routes>
    </div>
  );
};

export default RouterChat;
